import { Box, Grid, TextField } from '@mui/material';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import api from '../../api';
import PaymentTypeEnum from '../../enums/PaymentTypeEnum';
import ReceiveMethodEnum from '../../enums/ReceiveMethodEnum';
import Header from '../common/Header';
import Progress from '../common/Progress';
import CouponDialog from './CouponDialog';
import LiteMenuList from './LiteMenuList';
import MenuList from './MenuList';
import PaymentCoam from './PaymentCoam';
import PaymentHecto from './PaymentHecto';
import PaymentKSNET from './PaymentKSNET';
import PaymentKovan from './PaymentKovan';
import PaymentNice from './PaymentNice';
import PaymentSmartro from './PaymentSmartro';
import PaymentSoftBank from './PaymentSoftBank';
import PaymentCallGate from './PaymentCallGate';
import Point from './Point';
import PaymentPayStory from './PaymentPayStory';

@inject('commonStore', 'menuStore', 'cartStore', 'userStore', 'orderStore')
@observer
class Payment extends Component {
  async componentDidMount() {
    const { match, history, location, t, commonStore, menuStore, userStore, orderStore, cartStore } = this.props;

    // 매장 데이터 세팅
    await commonStore.setData(match.params.companyId.toLowerCase(), match.params.storeCode);

    // 유효성 검사
    if (location.state?.isLiteOrder) {
      if (!orderStore.liteOrder) {
        history.goBack();
        return;
      }
    } else if (cartStore.cartData.menus.length === 0) {
      alert(t('cart.error.empty'));
      history.push(`/${match.params.companyId.toLowerCase()}/${match.params.storeCode}${location.search}`);
      return;
    }

    // 일본 매장이 아닌 경우만 실행
    if (menuStore.storeData.culture !== 'ja-JP') {
      // 사용자 데이터 세팅
      if (!userStore.userData.phoneNumber) {
        userStore.setUserDataFromLocalStorage();

        // 포인트 사용 매장인 경우 사용자 포인트 조회
        if (menuStore.storeData.isPointUseable) {
          const response = await api.getUserPointByPhoneNumber(
            match.params.companyId.toLowerCase(),
            match.params.storeCode,
            userStore.userData.phoneNumber,
          );

          if (response.data.message === 'NOT_FOUND') {
            userStore.userData.isMember = false;
            userStore.saveUserData();

            history.push(`/${commonStore.companyId}/${commonStore.storeCode}/join${location.search}`);
          } else if (response.data.message === 'DUPLICATE') {
            userStore.userData.isMember = false;
            userStore.saveUserData();

            commonStore.setSnackbar(true, t('order.error.multipleMembersFound'));
            history.push(`/${commonStore.companyId}/${commonStore.storeCode}${location.search}`);
          } else if (response.data.message === 'SUCCESS') {
            userStore.userData.isMember = true;
            userStore.userData.isPointAdded = true;
            userStore.saveUserData();

            userStore.setUserPoint(response.data.user.Point);
          }
        }
      }

      if (!userStore.userData.phoneNumber) {
        // 라인미니앱이 아닌데 전화번호가 입력되어 있지 않다면 페이지 이동 처리
        if (location.state?.isLiteOrder) {
          // 마장동 주문인 경우 뒤로가기
          history.goBack();
        } else {
          // 일반 주문인 경우 주문정보 입력 페이지로 리다이렉트
          history.replace(`/${match.params.companyId.toLowerCase()}/${match.params.storeCode}/order${location.search}`);
        }
      }
    }
  }

  renderMenuList() {
    if (this.props.orderStore.liteOrder) {
      return <LiteMenuList />;
    } else {
      return <MenuList />;
    }
  }

  // 선택한 PG사별 결제 설정 ,,
  renderPaymentSection() {
    const { t, menuStore } = this.props;
    switch (Number(menuStore.storeData.paymentType)) {
      case PaymentTypeEnum.NICE:
        return <PaymentNice />;
      case PaymentTypeEnum.KOVAN:
        return <PaymentKovan />;
      case PaymentTypeEnum.SOFTBANK:
        return <PaymentSoftBank />;
      case PaymentTypeEnum.HECTO:
        return <PaymentHecto />;
      case PaymentTypeEnum.COAM:
        return <PaymentCoam />;
      case PaymentTypeEnum.SMARTRO:
        return <PaymentSmartro />;
      case PaymentTypeEnum.KSNET:
        return <PaymentKSNET />;
      case PaymentTypeEnum.CALLGATE:
        return <PaymentCallGate />;
      case PaymentTypeEnum.PAYSTORY:
        return <PaymentPayStory />;
      default:
        return t('payment.error.notConfigured');
    }
  }

  // 요청사항 변경
  handleChangeRequests = e => {
    let value = e.target.value;
    if (value.length > 20) {
      value = value.substr(0, 20);
    }

    this.props.orderStore.orderRequests = value;
  };

  // 상세주소 변경
  handleChangeAddressDetail = e => {
    this.props.userStore.userData.addressDetail = e.target.value;
  };

  getDeliveryCode = () => {
    const params = queryString.parse(this.props.location.search);
    return params.code;
  };

  render() {
    const { t, menuStore, cartStore, userStore, orderStore } = this.props;
    if (!menuStore.storeData || !cartStore.cartData) return <Progress />;
    return (
      <>
        {/* 헤더 */}
        <Header iconType="CART" title={t('payment.title.main')} />

        <div className="contents">
          {menuStore.storeData.isPointUseable && userStore.userData.isMember && userStore.userData.isPointAdded && (
            <Point />
          )}

          {/* 결제 메뉴 리스트 */}
          {this.renderMenuList()}

          {/* 일본 문화권인 경우 요청사항 및 주소를 결제 페이지에서 등록 */}
          {menuStore.storeData.culture !== 'ja-JP' && (
            <div style={{ marginTop: '25px' }}>
              <Grid item container direction={'column'} spacing={1}>
                {menuStore.storeData.isRequestInputUsed && (
                  <>
                    <Grid item>
                      <span style={{ fontSize: '13pt', fontWeight: 'bold' }}>
                        {t('order.label.request')} <span className="emphasis">({t('common.label.optional')})</span>
                      </span>
                    </Grid>
                    <Grid item>
                      <TextField
                        value={orderStore.orderRequests}
                        placeholder={t('order.placeholder.request')}
                        fullWidth
                        variant="outlined"
                        maxLength="20"
                        onChange={this.handleChangeRequests}
                      />
                    </Grid>
                  </>
                )}

                {cartStore.cartData.receiveMethodCode === ReceiveMethodEnum.DELIVERY && (
                  <Grid item container direction={'column'} spacing={1} style={{ marginTop: '5px' }}>
                    <Grid item>
                      <span style={{ fontSize: '13pt', fontWeight: 'bold' }}>
                        {t('common.label.address')} <span className="emphasis">({t('common.label.required')})</span>
                      </span>
                    </Grid>
                    <Grid item container direction={'row'}>
                      {this.getDeliveryCode() && (
                        <Grid item xs="auto">
                          <Box p={2}>
                            <span style={{ fontWeight: 600 }}>[{this.getDeliveryCode()}]</span>
                          </Box>
                        </Grid>
                      )}
                      <Grid item xs>
                        <TextField
                          name="addressDetail"
                          value={userStore.userData.addressDetail}
                          size="medium"
                          fullWidth
                          label={menuStore.storeData.addressHelperText || t('common.label.address')}
                          variant="outlined"
                          onChange={this.handleChangeAddressDetail}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </div>
          )}

          {/* 결제 */}
          {this.renderPaymentSection()}
        </div>

        <CouponDialog />
      </>
    );
  }
}

export default withTranslation()(withRouter(Payment));
